import { render, staticRenderFns } from "./AbsenceCreate.vue?vue&type=template&id=40b54749&scoped=true&"
import script from "./AbsenceCreate.vue?vue&type=script&lang=js&"
export * from "./AbsenceCreate.vue?vue&type=script&lang=js&"
import style0 from "./AbsenceCreate.vue?vue&type=style&index=0&id=40b54749&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b54749",
  null
  
)

export default component.exports